import React from "react";

export default class FeatureIcon extends React.Component {
    render() {
        return (
            <span className="icon" style={ this.props.spanStyle }>
                <i className={ this.props.iconName } style={ this.props.iconStyle }></i>
            </span>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/icons/feature-icon.jsx